/**
 * window.location.reload() previously took a forceReload parameter which
 * is now deprecated. TypeScript does not believe this parameter exists,
 * so we use this helper to cast as 'any' before using it.
 */
export const reload = (deprecatedForceReload?: boolean) => {
  (window.location as any).reload(deprecatedForceReload);
};
